module.exports = __webpack_public_path__ + "static/media/totally-turtles.b07e443d.png";